
import ProductVideoPreview from '@/components/ProductVideoPreview.vue'

const MAX_CARDS = 4

export default {
  name: 'ProductVideoShelf',
  components: { ProductVideoPreview },
  props: {
    videos: {
      type: Array,
      required: true,
    },
    customerMedia: {
      type: Object,
      default: null,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    customerCard: {
      type: Boolean,
      default: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    customerVideos() {
      return this.customerMedia?.videos || []
    },
    customerImages() {
      return this.customerMedia?.images || []
    },
    hasCustomer() {
      return this.customerVideos.length + this.customerImages.length > 0
    },
    customerTotal() {
      return (
        (this.customerMedia?.videos_count ?? this.customerVideos.length) +
        (this.customerMedia?.images_count ?? this.customerImages.length)
      )
    },
    showCustomerCard() {
      return this.customerCard && this.hasCustomer
    },
    productSlots() {
      return MAX_CARDS - (this.showCustomerCard ? 1 : 0)
    },
    shownVideos() {
      if (this.compact) {
        return this.expanded ? this.videos : this.videos.slice(0, 2)
      }
      if (
        !this.collapsible ||
        this.expanded ||
        this.videos.length <= this.productSlots
      ) {
        return this.videos
      }
      return this.videos.slice(0, this.productSlots - 1)
    },
    hiddenCount() {
      if (this.compact) return 0
      return this.videos.length - this.shownVideos.length
    },
    compactOverflow() {
      if (!this.compact || this.expanded) return 0
      return Math.max(this.videos.length - 2, 0)
    },
  },
}
